import { render, staticRenderFns } from "./ImportRegistryView.vue?vue&type=template&id=fcfc3426&scoped=true"
import script from "./ImportRegistryView.vue?vue&type=script&lang=js"
export * from "./ImportRegistryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcfc3426",
  null
  
)

export default component.exports